<template>
	<div>
		<div class="flex py-20">
			<div>当前位置：</div>
			<router-link to="/">首页<span>></span> </router-link>
			<router-link :to="titleRouter">{{title}}</router-link>
			<div v-if="text"><span>></span>{{text}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'breadcrumb',
		data() {
			return {
				
			};
		},
		props:{
			title:{
				type:String,
				default:''
			},
			titleRouter:{
				type:String,
				default:''
			},
			text:{
				type:String,
				default:''
			},
		},
	};
</script>

<style lang="scss" scoped="scoped">
	.flex{
		font-size: 14px;
		font-weight: 400;
		color: #666666;
		span{
			padding: 0 4px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/global/breadcrumb.vue